import React, { lazy } from 'react';
import { authPages, dashboardPagesMenu } from '../menu';
import Login from '../pages/presentation/auth/Login';
import UsersPage from '../pages/presentation/users/ListFluidPage';
import PushNotificationPage from '../pages/presentation/pushnotification/PushNotificationPage';
import ForgotPassword from '../pages/presentation/forgotpassword/ForgotPassword';
import ResetPassword from '../pages/presentation/resetpassword/ResetPassword';
import TemplatesPage from '../pages/presentation/templates/CreateTemplate';
import Profile from '../pages/presentation/profile/Profile';

const LANDING = {
    DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
};

// Public Routes
const publicRoutes = [
    {
        path: authPages.login.path,
        element: <Login />,
    },
    {
        path: authPages.signUp.path,
        element: <Login isSignUp />,
    },
    {
        path: authPages.forgotPassword.path,
        element: <ForgotPassword />,
    },
    {
        path: authPages.resetPassword.path,
        element: <ResetPassword />,
    },
];

// Private Routes
const privateRoutes = [
    {
        path: dashboardPagesMenu.dashboard.path,
        element: <LANDING.DASHBOARD />,
    },
    {
        path: dashboardPagesMenu.users.path,
        element: <UsersPage />,
    },
    {
        path: dashboardPagesMenu.template.path,
        element: <TemplatesPage />,
    },
    {
        path: dashboardPagesMenu.notification.path,
        element: <PushNotificationPage />,
    },
    {
        path: '/profile',
        element: <Profile />,
    },
];

// Exporting both arrays separately
const contents = {
    publicRoutes,
    privateRoutes,
};

export default contents;